// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    properties_find_properties: 'Buscando entre los emplazamientos',
    properties_property_file: 'Leyendo el emplazamiento',
    properties_properties_summary: 'Contando la cartera',
    properties_add_property_note: 'Añadiendo una nota al emplazamiento',
  },
  ca: {
    properties_find_properties: 'Cercant entre els emplaçaments',
    properties_property_file: 'Llegint l’emplaçament',
    properties_properties_summary: 'Comptant la cartera',
    properties_add_property_note: 'Afegint una nota a l’emplaçament',
  },
  en: {
    properties_find_properties: 'Looking through the properties',
    properties_property_file: 'Reading the property',
    properties_properties_summary: 'Counting the portfolio',
    properties_add_property_note: 'Adding a note to the property',
  },
  fr: {
    properties_find_properties: 'Recherche parmi les sites',
    properties_property_file: 'Lecture du site',
    properties_properties_summary: 'Bilan du portefeuille',
    properties_add_property_note: 'Ajout d’une note au site',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
